import { StrictMode } from 'react'
import './i18n'
import '@fontsource-variable/inter'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { getSupabaseClient } from './lib/supabase'

// @react-pdf/renderer references the Node `Buffer` global when generating a
// PDF in the browser. Vite's browser bundle does not provide it, which throws
// "Buffer is not defined" and breaks both the Template Studio PDF preview and
// the customer "Download PDF" flow. Polyfill it once at startup.
import { Buffer } from 'buffer'

declare global {
  interface Window {
    Buffer: typeof Buffer
  }
}

if (typeof globalThis.Buffer === 'undefined') {
  ;(globalThis as typeof globalThis & { Buffer: typeof Buffer }).Buffer = Buffer
}

// Supabase's auto-refresh can fail with "Invalid Refresh Token" / "Refresh
// Token Not Found" when a locally persisted session has been revoked or expired
// server-side (e.g. the user signed out on another device). That failure
// surfaces as an unhandled promise rejection from the SDK's internal refresh
// timer, bypassing our own try/catch blocks. Catch it globally, stop it from
// being reported as a crash, and cleanly sign the user out locally so they can
// simply sign in again instead of seeing an error.
function isInvalidRefreshTokenError(reason: unknown): boolean {
  if (!reason || typeof reason !== 'object') return false;
  const message = (reason as { message?: string }).message || '';
  return (
    message.includes('Invalid Refresh Token') ||
    message.includes('Refresh Token Not Found')
  );
}

window.addEventListener('unhandledrejection', (event) => {
  if (isInvalidRefreshTokenError(event.reason)) {
    // Prevent the error tracker / console from treating it as a fatal crash.
    event.preventDefault();
    // Clear the stale local session only (no network call needed).
    getSupabaseClient()?.auth.signOut({ scope: 'local' }).catch(() => {});
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)